module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-ui/static-1.2723/img/callout-wave.svg"


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/ecosystem-marketplace-apps/node_modules/bender-webpack/lib/bender-url-loader.js!./img/callout-wave.svg
// module id = 896
// module chunks = 209 210 211 212